// src/pages/Admin/Casting/components/MatsSidebar.jsx
import React from "react";
import { FaLock, FaUnlock } from "react-icons/fa";

export default function MatsSidebar({
  mats = [],
  selectedMat,
  onSelectMat,
  currentLabel,
  isOpen,
  onToggleCurrentMat,
}) {
  return (
    <div className="rounded-3xl bg-white/80 dark:bg-slate-900/70 backdrop-blur ring-1 ring-black/5 dark:ring-white/10 shadow-xl p-4">
      <div className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-300">
        Tapis (1 → 10)
      </div>

      <div className="mt-3 grid grid-cols-5 gap-2">
        {Array.from({ length: 10 }).map((_, i) => {
          const n = i + 1;
          const m = mats.find((x) => Number(x.mat_number) === n);
          const open = m?.is_open !== undefined ? Boolean(m.is_open) : true;
          const isSelected = Number(selectedMat) === n;

          return (
            <button
              key={n}
              onClick={() => onSelectMat?.(n)}
              className={[
                "h-11 rounded-2xl text-sm font-extrabold ring-1 transition",
                isSelected
                  ? "bg-blue-600 text-white ring-blue-600"
                  : "bg-white/70 dark:bg-slate-900/50 text-slate-900 dark:text-white ring-slate-200 dark:ring-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800",
              ].join(" ")}
              title={`Tapis ${n}`}
            >
              {n}
              <div className="text-[10px] font-semibold opacity-80">
                {open ? "OUVERT" : "FERMÉ"}
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div className="text-sm font-semibold text-slate-800 dark:text-white truncate">
          {currentLabel}
        </div>

        <button
          onClick={onToggleCurrentMat}
          className={[
            "inline-flex items-center gap-2 h-9 px-3 rounded-2xl text-sm font-semibold ring-1 transition",
            isOpen
              ? "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-200 dark:ring-emerald-800/60"
              : "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-900/30 dark:text-rose-200 dark:ring-rose-800/60",
          ].join(" ")}
          title="Ouvrir/Fermer le tapis"
        >
          {isOpen ? <FaUnlock /> : <FaLock />}
          {isOpen ? "Ouvert" : "Fermé"}
        </button>
      </div>
    </div>
  );
}
